/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import lang from 'quasar/lang/es.js'
import iconSet from 'quasar/icon-set/material-icons.js'

import {Ripple,TouchHold,ClosePopup,Notify,LocalStorage,AppFullscreen,BottomSheet,Loading,Dialog,AppVisibility} from 'quasar'

export default { config: {},lang,iconSet,directives: {Ripple,TouchHold,ClosePopup},plugins: {Notify,LocalStorage,AppFullscreen,BottomSheet,Loading,Dialog,AppVisibility} }
